import { Config } from '.';

const config: Config = {
    API_URL: 'https://api.ga-api-management-tool.co.uk',
};

export default config;
